import React from 'react'
import { darkGray } from '../../styles/material-ui-theme-v2'
import { Box } from '@material-ui/core'

export interface IYumEmptyStateProps {
  text: string
  Icon: any
  extraPx?: number
  fullHeight?: boolean
}

export default function YumEmptyState(props: IYumEmptyStateProps) {
  const { text, Icon, extraPx, fullHeight } = props
  const topPx = 278 + (extraPx || 0)
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        /* @ts-ignore */
        gap: '20px',
        height: fullHeight ? `100%` : `calc(100vh - ${topPx}px)`,
        color: darkGray,

        /* iOS Safari 11.2, Safari 11 */
        '@supports (bottom: constant(safe-area-inset-bottom))': {
          height: fullHeight
            ? `100%`
            : `calc(100vh - ${topPx}px - constant(safe-area-inset-top) - constant(safe-area-inset-bottom))`,
        },

        /* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ */
        '@supports (bottom: env(safe-area-inset-bottom))': {
          height: fullHeight
            ? `100%`
            : `calc(100vh - ${topPx}px - env(safe-area-inset-top) - env(safe-area-inset-bottom))`,
        },
      }}
    >
      <Icon style={{ width: '72px', height: '72px' }} />
      <div>{text}</div>
    </Box>
  )
}
